import React from 'react';
import { IcoTrash, IcoClose } from '../dashboard/DashIcons';

export default function ConfirmDeleteModal({ message, onConfirm, onCancel }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1rem',
    }}>
      <div style={{
        background: 'white', borderRadius: '14px', padding: '2rem',
        width: '100%', maxWidth: '420px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
      }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1.5rem' }}>
          <div style={{
            width: 44, height: 44, borderRadius: '10px',
            background: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <IcoTrash size={20} color="#ef4444" strokeWidth={2}/>
          </div>
          <div>
            <h3 style={{ margin: '0 0 0.35rem', fontSize: '1rem', fontWeight: '700', color: '#111827' }}>
              Confirm Delete
            </h3>
            <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280', lineHeight: 1.5 }}>
              {message || 'Are you sure you want to delete this? This action cannot be undone.'}
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '0.55rem 1.1rem', background: '#f3f4f6', border: 'none',
              borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '0.875rem',
              color: '#374151',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '0.55rem 1.1rem',
              background: 'linear-gradient(135deg, #ef4444, #dc2626)',
              border: 'none', borderRadius: '8px', cursor: 'pointer',
              fontWeight: '700', fontSize: '0.875rem', color: 'white',
              display: 'flex', alignItems: 'center', gap: '0.4rem',
            }}
          >
            <IcoTrash size={14} color="white" strokeWidth={2}/> Delete
          </button>
        </div>
      </div>
    </div>
  );
}
